import { Header } from '../components/Header'
import { Footer } from '../components/Footer'
import { useTitle } from '../lib/title'

export default function Terms() {
  useTitle('Terms of Service')
  return (
    <>
      <Header />
      <main className="wrap prose">
        <h1>Terms of Service</h1>
        <p className="muted">Last updated: 19 April 2026</p>

        <h2>1. About this service</h2>
        <p>
          calendarfeedback.com (the "Service") lets a user invite <code>bot@calendarfeedback.com</code>
          to a Google Calendar event. After the event ends, the Service sends attendees a one-click
          anonymous feedback email and distributes the aggregate score to the organiser and everyone
          who voted. The Service is operated by Maksym Trofimenko ("we", "us"), a sole trader based
          in the United Kingdom.
        </p>

        <h2>2. Acceptance</h2>
        <p>
          By inviting the bot to a meeting, signing in to the dashboard, or using any feature of the
          Service, you ("you", the "user") agree to these Terms. If you do not agree, do not use the
          Service.
        </p>

        <h2>3. Who may use the Service</h2>
        <p>
          You must be at least 16 years old, have the authority to bind the organisation on whose
          behalf you are using the Service (if any), and must only invite the bot to meetings where
          you are entitled to do so under your organisation's policies and applicable law.
        </p>

        <h2>4. Acceptable use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service to harass, defame, or target any individual or group.</li>
          <li>Invite the bot to meetings that you do not own or organise, or where doing so would
              breach your organisation's policies.</li>
          <li>Attempt to de-anonymise respondents, vote multiple times from the same token, or
              otherwise tamper with the Service.</li>
          <li>Use automated means to generate feedback, invite mass meetings solely to farm
              responses, or abuse the sending infrastructure.</li>
          <li>Use the Service to process sensitive personal data (special-category data under UK
              GDPR) without lawful basis.</li>
        </ul>
        <p>
          We may suspend or remove access to the Service, with or without notice, if we reasonably
          believe these rules have been breached.
        </p>

        <h2>5. Privacy</h2>
        <p>
          Our handling of personal data is described in our <a href="/privacy">Privacy Policy</a>,
          which forms part of these Terms.
        </p>

        <h2>6. Intellectual property</h2>
        <p>
          The Service, including its software, design, and content (other than your own meeting
          data), is owned by us. You receive a non-exclusive, non-transferable, revocable licence
          to use the Service as provided.
        </p>

        <h2>7. No warranty</h2>
        <p>
          The Service is provided <strong>"as is" and "as available"</strong>, without warranty of
          any kind, whether express or implied, including but not limited to warranties of
          merchantability, fitness for a particular purpose, non-infringement, uninterrupted
          operation, or that delivery of emails will be timely or guaranteed.
        </p>
        <p>
          We rely on third-party providers (Google Calendar, Gmail, cloud hosting). We are not
          responsible for their outages, rate-limiting, or changes to their APIs.
        </p>

        <h2>8. Limitation of liability</h2>
        <p>
          To the maximum extent permitted by law, in no event will we be liable to you for any
          indirect, incidental, special, consequential, or punitive damages, loss of profits,
          business interruption, loss of data, or loss of goodwill, arising out of or in connection
          with your use of the Service, even if we have been advised of the possibility of such
          damages.
        </p>
        <p>
          Our total aggregate liability for any claim arising out of or relating to the Service
          (whether in contract, tort, or otherwise) is limited to the greater of (a) the total
          amount you paid to use the Service in the twelve months immediately preceding the event
          giving rise to the claim, or (b) one hundred pounds sterling (£100).
        </p>
        <p>
          Nothing in these Terms excludes or limits any liability that cannot lawfully be excluded
          or limited under UK law, including liability for death or personal injury caused by
          negligence, or fraud.
        </p>

        <h2>9. Indemnity</h2>
        <p>
          You agree to indemnify and hold us harmless from any third-party claim arising out of
          your misuse of the Service or your breach of these Terms, including reasonable legal fees.
        </p>

        <h2>10. Changes to the Service and these Terms</h2>
        <p>
          We may change, suspend, or discontinue all or part of the Service at any time. We may
          update these Terms; the "Last updated" date above will change when we do. Continued use
          of the Service after a change constitutes acceptance of the updated Terms.
        </p>

        <h2>11. Termination</h2>
        <p>
          You may stop using the Service at any time. You can revoke the Service's Google access
          via your <a href="https://myaccount.google.com/permissions">Google account permissions
          page</a>. We may terminate or suspend your access at our discretion, with or without
          notice, for any breach of these Terms.
        </p>

        <h2>12. Governing law and jurisdiction</h2>
        <p>
          These Terms are governed by the laws of England and Wales. Any dispute arising out of or
          in connection with these Terms is subject to the exclusive jurisdiction of the courts of
          England and Wales.
        </p>

        <h2>13. Contact</h2>
        <p>
          Questions about these Terms: <a href="mailto:privacy@calendarfeedback.com">privacy@calendarfeedback.com</a>.
        </p>
      </main>
      <Footer />
    </>
  )
}
